// Formatting helpers (currency + period labels).

const CURRENCY: string = (import.meta.env.VITE_CURRENCY as string | undefined) ?? 'INR';
const LOCALE: string = (import.meta.env.VITE_LOCALE as string | undefined) ?? 'en-IN';

export function formatCurrency(value: number): string {
  const safe = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat(LOCALE, {
    style: 'currency',
    currency: CURRENCY,
    maximumFractionDigits: Math.abs(safe) >= 10_000 ? 0 : 2,
  }).format(safe);
}

/** '2026-W31' -> 'W31 ’26' · '2026-08' -> 'Aug 2026' · '2026' -> '2026' */
export function formatDateKey(key: string): string {
  const week = key.match(/^(\d{4})-W(\d{2})$/);
  if (week) return `W${Number(week[2])} ’${week[1].slice(2)}`;

  const month = key.match(/^(\d{4})-(\d{2})$/);
  if (month) {
    return new Date(Number(month[1]), Number(month[2]) - 1, 1).toLocaleDateString(LOCALE, {
      month: 'short',
      year: 'numeric',
    });
  }
  return key;
}

export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
